import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header/Header';
import ProgramDetails from './ProgramDetails/ProgramDetails';
import Footer from './Footer/Footer';
import Curriculum from './Curriculum/Curriculum.js';
import BookTrail from './BookTrail/BookTrail.js';
import Testimonial from './Testimonial/Testimonial.js';
import FAQ from './FAQ/Faq.js';
import Query from './Query/Query.js';
import Center from './Centers/Center.js';
import ExplorePlan from './ExplorePlan/ExplorePlan.js';
import PlanDetail from './PlanDetails/PlanDetail.js';
import Signup from './Signup/Signup.js';
import GetInTouch from './GetInTouch/GetInTouch.js';
import Glimpse from './Glimpse/Glimpse.js';
import UserTracker from './UserTracker.js';
import SuccessPage from './BookTrail/SuccessPage.js';
import Popup from './Popup/Popup.js';
import ThankyouPage from './BookTrail/ThankyouPage.js';
import { initFacebookPixel } from './facebookPixel';
import Reschedule from './BookTrail/Reschedule.js';
import FloatingWhatsApp from './Signup/FloatingWhatsApp.js';

const HomePage = () => (
  <>
    <Header />
    <ProgramDetails />
    <Curriculum />
    <Center />
    {/* <PlanDetail/> */}
    <Testimonial />
    <ExplorePlan />
    // <GetInTouch />
    <FAQ />
    <Glimpse />
    <Footer />
    {/* <Popup/> */}
    <FloatingWhatsApp />
    {/* <Query/> */}
    <Signup />
  </>
);

function App() {
  useEffect(() => {
    initFacebookPixel(); // Initialize Facebook Pixel on app load
  }, []);
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Query />} />
          <Route path="/book-trial" element={<HomePage />} />
          <Route path="/query" element={<Query />} />
          <Route path="/thankyou-page" element={<>
          <ThankyouPage />
          </>} />
          <Route path="/trial-form" element={<>
          <BookTrail />
          </>} />
          <Route path="/SuccessPage" element={<>
          <SuccessPage />
          </>} />
          <Route path="/reschedule" element={<>
          <Reschedule />
          </>} />
          <Route path="*" element={<Navigate to="/query" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
